module.exports = __webpack_public_path__ + "assets/img/newsIconBg.f43da089.png";